type SupportedEvent = React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>;

const createNonPropagatingEventHandler = (handler: (event: SupportedEvent) => void) => {
	return (event: SupportedEvent) => {
		event.preventDefault();
		event.stopPropagation();
		handler(event);
	};
};

export default createNonPropagatingEventHandler;
